/* eslint-disable import/no-extraneous-dependencies */
import { rest } from 'msw';
import { mockServerApi } from '@/common/utils';
import { GAME_MECHANICS, GAMES } from '../data/games';
import { USERS } from '../data';

export const gamesRequests = (msw: typeof rest) => [
  msw.get(mockServerApi('/types/games/mechanics'), (_, res, ctx) => res(
    ctx.status(200),
    ctx.json({
      items: GAME_MECHANICS,
    }),
  )),

  msw.post(mockServerApi('/types/games/thumbnail'), (_, res, ctx) => res(
    ctx.status(200),
    ctx.json({
      message: 'File uploaded successfully.',
      url: 'https://cdn-icons-png.flaticon.com/512/3408/3408506.png',
    }),
  )),

  msw.post(mockServerApi('/types/games'), (req: { body: { name: string, mechanicId: number } }, res, ctx) => {
    const id = GAMES.length + 1;
    const mechanic = GAME_MECHANICS.find((n) => n.id === +req.body.mechanicId);

    const game = {
      ...req.body,
      id,
      isHidden: true,
      createdAt: new Date(Date.now()).getTime(),
      updatedAt: new Date(Date.now()).getTime(),
      mechanic,
      creator: USERS[0],
    };

    GAMES.push(game);

    return res(
      ctx.status(201),
      ctx.json(game),
    );
  }),

  msw.patch(mockServerApi('/types/games/:id'), (req: { params: { id: string }, body }, res, ctx) => {
    const gameIndex = GAMES.findIndex((n) => n.id === +req.params.id);
    const game = GAMES.at(gameIndex);

    const updateGame = {
      ...game,
      ...req.body,
      id: game.id,
      creator: game.creator,
      createdAt: game.createdAt,
      mechanic: game.mechanic,
      updatedAt: new Date(Date.now()).getTime(),
    };

    GAMES.splice(gameIndex, 1, updateGame);

    return res(
      ctx.status(200),
      ctx.json(updateGame),
    );
  }),

  msw.delete(mockServerApi('/types/games/:id'), (req: { params: { id: string }, body }, res, ctx) => {
    const gameIndex = GAMES.findIndex((n) => n.id === req.params.id);
    GAMES.splice(gameIndex, 1);

    return res(
      ctx.status(200),
      ctx.json({}),
    );
  }),

  msw.get(mockServerApi('/types/games'), (_, res, ctx) => res(
    ctx.status(200),
    ctx.json({
      items: [].concat(GAMES),
    }),
  )),
];

export default gamesRequests;
